'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _FormValidationService = require('./../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _lodash = require('lodash');

var _enquiryConfirmationModal = require('./enquiryConfirmation.modal.html');

var _enquiryConfirmationModal2 = _interopRequireDefault(_enquiryConfirmationModal);

var _contactEditModal = require('./contactEdit.modal.html');

var _contactEditModal2 = _interopRequireDefault(_contactEditModal);

var _sendMessageModal = require('./sendMessage.modal.html');

var _sendMessageModal2 = _interopRequireDefault(_sendMessageModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WelcomeCentreController = function () {
  function WelcomeCentreController(authService, $stateParams, enums, loadingService, appConfig, $scope, enquiryService, $uibModal, userService, $state, pushService, messagingService, contactService, lookupService, $q, enquirySourcesManagementService) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, WelcomeCentreController);
    this.authService = authService;
    this.enums = enums;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.enquiryService = enquiryService;
    this.loadingService = loadingService;
    this.$uibModal = $uibModal;
    this.userService = userService;
    this.$state = $state;
    this.pushService = pushService;
    this.messagingService = messagingService;
    this.contactService = contactService;
    this.lookupService = lookupService;
    this.$q = $q;
    this.enquirySourcesManagementService = enquirySourcesManagementService;

    this.formValidationService = new _FormValidationService2.default();

    //If Accounts admin, redirect to Invoice List
    var isAccountsAdmin = (0, _lodash.find)(this.authService.authData.userRoles, function (ur) {
      return ur.roleId == 5 && ur.entityId == _this.authService.authData.currentLocation.key;
    });
    if (isAccountsAdmin != null) {
      this.$state.go('invoiceList');
    } else {
      if (!authService.validateUser(false, 'Enquiry', enums.PERMISSION_TYPE.Add, true)) {
        return;
      }
    }

    this.searchContactUrl = appConfig.apiServiceBaseUri + 'api/contact/search/' + authService.authData.currentLocation.key + '/';
    this.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';

    this.enquiry = $stateParams.enquiry || {
      entityId: authService.authData.currentLocation.key,
      enquiryType: enums.ENQUIRY_TYPE.Sales,
      enquiryVehicles: [],
      testDrives: [],
      enquiryPrices: [],
      state: enums.ENQUIRY_STATE.Open,
      criteria: null,
      enquirySourceId: null
    };

    this.currentEnquiries = [];

    this.selectOptions = {};
    this.selectDefaults = {};
    this.locationUsers = [];
    this.userMatrix = [];
    this.serviceVehicle = null;
    this.userStats = [];

    this.initializeLookups().then(function () {
      _this.initializeEnums();
      _this.initializeContactEnums();
      _this.configureForm();
      _this.loadEnumLists();
      _this.getUserStats();
      _this.initializeEnquirySources();
    });

    this.contactSelected = this.contactSelected.bind(this);
    this.contactSearched = this.contactSearched.bind(this);

    this.getLocationUsers();

    this.isReceptionist = this.authService.authData.currentLocation.receptionistWelcomeCentre || authService.isReceptionist();

    if (!this.isReceptionist) {
      this.enquiry.ownerId = this.authService.authData.userId;
    }

    this.createNewContact = false;

    this.authService.getLocationExtendedProperties('salutationEnabled');
  }

  (0, _createClass3.default)(WelcomeCentreController, [{
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'ENQUIRY_TYPE', propName: 'enquiryType', defaultOption: true }, { enumName: 'ENQUIRY_CONTACT', propName: 'enquiryContact', defaultOption: true }, { enumName: 'ENQUIRY_ORIGINATION', propName: 'enquiryOrigination', defaultOption: true }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption);
        ctrl.selectOptions[item.propName] = enumsArray;
        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
        ctrl.updateModelFromSelect(item.propName);
      });
    }
  }, {
    key: 'getDefaultOption',
    value: function getDefaultOption(enumsArray, propName) {
      var propVal = void 0;

      try {
        propVal = eval('this.enquiry.' + propName);
      } catch (e) {}

      if (propVal) {
        return (0, _lodash.find)(enumsArray, function (o) {
          return o.id === propVal;
        });
      } else {
        return enumsArray[0];
      }
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'updateModelFromSelect',
    value: function updateModelFromSelect(modelProperty) {
      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

      var val = this.selectDefaults[selectDefaultProperty][idProperty];

      try {
        eval('this.enquiry.' + modelProperty + ' = ' + val);
      } catch (e) {}

      if (modelProperty === 'enquiryType') {
        this.loadEnquirySubTypes();
      }
    }
  }, {
    key: 'loadEnquirySubTypes',
    value: function loadEnquirySubTypes() {
      var objList = [];

      if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Sales) {
        objList.push({ id: 1, name: 'New' });
        objList.push({ id: 2, name: 'Used' });
        objList.push({ id: 3, name: 'Unsure' });
        objList.push({ id: 4, name: 'Buy In' });
        objList.push({ id: 5, name: 'Finance Quote' });
      } else if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Aftersales) {
        objList.push({ id: 5, name: 'Service Booking' });
        objList.push({ id: 6, name: 'Repairs Required' });
        objList.push({ id: 7, name: 'Parts' });
        objList.push({ id: 8, name: 'Tech Query' });
      }

      objList.unshift({ id: null, name: 'Please Select' });

      this.selectOptions.enquirySubType = objList;
      this.selectDefaults.enquirySubType = this.getDefaultOption(objList, 'enquirySubType');
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      ctrl.formValidationService.initialize(ctrl.enquiry);

      ctrl.formValidationService.addField({
        fieldName: 'enquiryType',
        displayName: 'Enquiry Type',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'enquiryContact',
        displayName: 'Enquiry Contact',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'enquirySubType',
        displayName: 'Enquiry SubType',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'enquiryOrigination',
        displayName: 'Contact Method',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'ownerId',
        displayName: 'Owner',
        required: true,
        type: 'text'
      });
    }
  }, {
    key: 'clearContact',
    value: function clearContact() {
      this.enquiry.contactId = null;
      this.enquiry.contact = null;
    }
  }, {
    key: 'getLocationUsers',
    value: function getLocationUsers() {
      var _this2 = this;

      var ctrl = this;
      ctrl.userService.getLocationUsers(ctrl.authService.authData.currentLocation.key, false).then(function (response) {
        if (response.data.length) {
          ctrl.locationUsers = response.data;
          _this2.updateUserMatrix();
        }
      });
    }
  }, {
    key: 'updateUserMatrix',
    value: function updateUserMatrix() {
      var _this3 = this;

      var limit = 5;
      var selectedUsers = (0, _lodash.filter)(this.locationUsers, function (o) {
        return o.workType === _this3.enquiry.enquiryType;
      });
      this.userMatrix = this.listToMatrix(selectedUsers, limit);
    }
  }, {
    key: 'listToMatrix',
    value: function listToMatrix(list, elementsPerSubArray) {
      var matrix = [],
          i,
          k;

      for (i = 0, k = -1; i < list.length; i++) {
        if (i % elementsPerSubArray === 0) {
          k++;
          matrix[k] = [];
        }

        matrix[k].push(list[i]);
      }

      return matrix;
    }
  }, {
    key: 'contactSearched',
    value: function contactSearched(data) {
      this.createNewContact = data.length === 0;
      return data;
    }
  }, {
    key: 'contactSelected',
    value: function contactSelected(item) {
      if (item) {
        this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchContacts');
        this.enquiry.contactId = item.originalObject.contactId;
        this.enquiry.contact = item.originalObject;

        if (this.authService.authData.currentLocation.salutationEnabled.enabled) {
          this.enquiry.contact.name = this.getSalutationById(this.enquiry.contact.contactTitleId) + ' ' + this.enquiry.contact.name;
        }
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.enquiry = {
        entityId: this.authService.authData.currentLocation.key,
        enquiryType: this.enums.ENQUIRY_TYPE.Sales,
        enquiryVehicles: [],
        testDrives: [],
        enquiryPrices: [],
        state: this.enums.ENQUIRY_STATE.Open
      };

      if (!this.isReceptionist) {
        this.enquiry.ownerId = this.authService.authData.userId;
      }

      this.clearVehicle();

      this.initializeEnums();

      this.formValidationService = new _FormValidationService2.default();

      this.configureForm();

      this.createNewContact = false;
    }
  }, {
    key: 'massageData',
    value: function massageData() {
      var ctrl = this;

      //Massage Data
      if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.Unsure) {
        ctrl.enquiry.subject = 'Unsure';
      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.BuyIn) {
        ctrl.enquiry.subject = 'Buy In';
      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.FinanceQuote) {
        ctrl.enquiry.subject = 'Finance Quote';
      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.ServiceBooking) {
        ctrl.enquiry.subject = 'Service Booking';
      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.RepairsRequired) {
        ctrl.enquiry.subject = 'Repairs Required';
      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.Parts) {
        ctrl.enquiry.subject = 'Parts';
      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.TechQuery) {
        ctrl.enquiry.subject = 'Technical Query';
      } else if (ctrl.enquiry.enquiryVehicles.length) {
        ctrl.enquiry.subject = ctrl.enquiry.enquiryVehicles[0].vehicle.model + ' ' + ctrl.enquiry.enquiryVehicles[0].vehicle.variant;
      }

      //Remove All Vehicle Objects and just leave their IDs
      ctrl.enquiry.enquiryVehicles.map(function (ev) {
        ev.vehicle = null;
      });

      this.enquiry.contact = null;

      if (this.enquiry.criteria) {
        this.enquiry.criteria.brand = null;
        this.enquiry.criteria.brandModel = null;
      }

      /*
      * If this is aftersales enquiry
      * The service vehicle should become part of the enquiry
      * The service vehicle will be marked as Deleted
      * The enquiry will be marked as closed
      */
      if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Aftersales) {
        this.enquiry.enquiryVehicles.push({
          isSelected: true,
          vehicle: this.serviceVehicle
        });
      }
    }
  }, {
    key: 'editEnquiry',
    value: function editEnquiry() {
      var ctrl = this;
      var isValid = false;

      isValid = ctrl.formValidationService.validateForm();

      var searchText = $('#searchContacts_value').val();
      if (!this.enquiry.contactId) {
        if (!searchText) {
          ctrl.formValidationService.addModelError('contactId', 'Please select a contact or enter showroom entry details');
          isValid = isValid && false;
        } else {
          ctrl.addShowroomEntry(searchText);
          return;
        }
      }

      isValid &= this.customValidation();

      if (!isValid) {
        return;
      }

      this.massageData();

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editEnquiry', 'Saving Changes ...');

      ctrl.enquiryService.editEnquiry(ctrl.enquiry).then(function (response) {
        ctrl.state = 'Saved';

        /*
        * #714
        * Update OwnerId of the Contact to the person 
        * whose been assigned this enquiry
        * otherwise the contact will be owned by Showroom Host
        */
        ctrl.contactService.updateOwner(ctrl.enquiry.contactId, ctrl.enquiry.ownerId);

        ctrl.enquiry.enquiryId = response.data;

        if (ctrl.isReceptionist) {
          ctrl.enquiry.ownerImageUrl = (0, _lodash.find)(ctrl.locationUsers, function (o) {
            return o.userId === ctrl.enquiry.ownerId;
          }).imageUrl;
          ctrl.enquiry.isAccepted = false;
          ctrl.currentEnquiries.push((0, _assign2.default)({}, ctrl.enquiry));
          ctrl.getUserStats();
        } else {
          ctrl.$state.go('enquiryEdit', { enquiryId: ctrl.enquiry.enquiryId });
        }

        ctrl.reset();
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(function (item) {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'chooseDifferentOwner',
    value: function chooseDifferentOwner(enquiry) {
      var ctrl = this;

      ctrl.$scope.enquiry = enquiry;
      ctrl.$scope.ownerUpdated = ctrl.ownerUpdated.bind(this);

      ctrl.modalInstance = ctrl.$uibModal.open({
        template: _enquiryConfirmationModal2.default,
        scope: ctrl.$scope
      });
    }
  }, {
    key: 'ownerUpdated',
    value: function ownerUpdated(newOwnerId) {
      var ctrl = this;
      ctrl.$scope.enquiry.ownerId = newOwnerId;
      ctrl.$scope.enquiry.ownerImageUrl = (0, _lodash.find)(ctrl.locationUsers, function (o) {
        return o.userId === ctrl.$scope.enquiry.ownerId;
      }).imageUrl;
      ctrl.$scope.$broadcast('welcomeCentre:ownerUpdated', { enquiryId: ctrl.$scope.enquiry.enquiryId });
      ctrl.modalInstance.close();
    }
  }, {
    key: 'getReturnParams',
    value: function getReturnParams(newContactId, contact) {
      if (newContactId) {
        this.enquiry.contactId = newContactId;
        this.enquiry.contact = {
          name: contact.contactPerson.firstName + ' ' + contact.contactPerson.lastName,
          phone: contact.contactPhones.length ? contact.contactPhones[0].phone : null,
          email: contact.contactEmails.length ? contact.contactEmails[0].email : null,
          reg: contact.currentReg
        };
      }

      return {
        stateName: 'welcomeCentre',
        params: { enquiry: this.enquiry }
      };
    }
  }, {
    key: 'notifyOwner',
    value: function notifyOwner(contact) {
      var ctrl = this;

      ctrl.formValidationService.resetValidations();

      if (!ctrl.enquiry.enquiryOrigination) {
        ctrl.formValidationService.addModelError('enquiryOrigination', 'Please provide a value for Select Method');
        return;
      }

      ctrl.currentEnquiries.push({
        contactId: contact.contactId,
        contactName: contact.name,
        contactMethod: ctrl.enquiry.enquiryOrigination,
        enquiryId: contact.enquiry.enquiryId,
        ownerId: contact.enquiry.ownerId,
        ownerImageUrl: contact.enquiry.ownerImageUrl,
        isExisting: true
      });

      ctrl.reset();
    }
  }, {
    key: 'pendingEnquiryAccepted',
    value: function pendingEnquiryAccepted(enquiryId) {
      var acceptedEnquiry = (0, _lodash.find)(this.currentEnquiries, function (e) {
        return e.enquiryId === enquiryId;
      });
      this.currentEnquiries = (0, _lodash.without)(this.currentEnquiries, acceptedEnquiry);
    }
  }, {
    key: 'showSendMessage',
    value: function showSendMessage() {
      var ctrl = this;

      ctrl.$scope.recipeintType = '1';
      ctrl.$scope.enums = ctrl.enums;
      ctrl.$scope.locationUsers = ctrl.locationUsers;
      ctrl.$scope.pushService = ctrl.pushService;
      ctrl.$scope.messagingService = ctrl.messagingService;
      ctrl.$scope.myUserId = ctrl.authService.authData.userId;

      ctrl.$scope.sendMessage = ctrl.sendMessage;
      ctrl.$scope.cancelSend = ctrl.cancelSend.bind(this);

      ctrl.modalInstance = ctrl.$uibModal.open({
        template: _sendMessageModal2.default,
        scope: ctrl.$scope
      });

      ctrl.$scope.modalInstance = ctrl.modalInstance;
    }
  }, {
    key: 'cancelSend',
    value: function cancelSend() {
      this.modalInstance.close();
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage() {
      var _this4 = this;

      var fnFilter = void 0;
      var userIds = void 0;

      switch (this.recipeintType) {
        case "1":
          fnFilter = function fnFilter(o) {
            return true;
          };
          break;

        case "2":
          fnFilter = function fnFilter(o) {
            return o.workType === _this4.enums.USER_WORK_TYPE.Sales;
          };
          break;

        case "3":
          fnFilter = function fnFilter(o) {
            return o.workType === _this4.enums.USER_WORK_TYPE.Aftersales;
          };
          break;
      }

      if (fnFilter) {
        userIds = (0, _lodash.filter)(this.locationUsers, fnFilter).map(function (u) {
          return u.userId;
        });
      } else {
        userIds = this.messageRecipients.map(function (u) {
          return u.userId;
        });
      }

      this.pushService.messageHub.sendMessage(userIds, this.msgBody);

      userIds.map(function (uid) {
        var msg = {
          senderId: _this4.myUserId,
          userId: uid,
          subject: 'New Message Received',
          body: (0, _stringify2.default)({
            msg: _this4.msgBody
          })
        };

        _this4.messagingService.addMessage(msg);
      });

      alert('Message has been sent');
      this.modalInstance.close();
    }
  }, {
    key: 'initializeContactEnums',
    value: function initializeContactEnums() {
      var ctrl = this;

      ctrl.$scope.contactTypes = ctrl.convertEnumToKeyValueList(ctrl.enums.CONTACT_TYPE);
      ctrl.$scope.personTitles = ctrl.convertEnumToKeyValueList(ctrl.enums.PERSON_TITLE);
    }
  }, {
    key: 'showNewContact',
    value: function showNewContact() {
      var ctrl = this;

      ctrl.$scope.errMsg = '';
      ctrl.$scope.quickEdit = false;
      ctrl.$scope.editContact = this.editContact.bind(this);
      ctrl.$scope.salutationEnabled = this.authService.authData.currentLocation.salutationEnabled.enabled;

      ctrl.$scope.contact = {
        entityId: ctrl.authService.authData.currentLocation.key,
        ownerId: ctrl.authService.authData.userId,
        contactType: ctrl.enums.CONTACT_TYPE.Customer,
        contactPerson: {
          title: this.authService.authData.currentLocation.salutationEnabled.enabled ? ctrl.enums.PERSON_TITLE.Mr : ctrl.enums.PERSON_TITLE.Other
        },
        partner: null,
        address: {}
      };

      ctrl.modalInstance = ctrl.$uibModal.open({
        template: _contactEditModal2.default,
        scope: ctrl.$scope
      });
    }
  }, {
    key: 'showEditContact',
    value: function showEditContact() {
      var ctrl = this;

      ctrl.$scope.errMsg = '';
      ctrl.$scope.quickEdit = true;
      ctrl.$scope.editContact = this.quickEditContact.bind(this);
      ctrl.$scope.salutationEnabled = this.authService.authData.currentLocation.salutationEnabled.enabled;

      ctrl.$scope.contact = {
        entityId: ctrl.authService.authData.currentLocation.key,
        contactId: ctrl.enquiry.contact.contactId,
        ownerId: ctrl.authService.authData.userId,
        contactType: ctrl.enquiry.contact.contactTypeId,
        contactPerson: {
          title: ctrl.enquiry.contact.contactTitleId,
          firstName: ctrl.enquiry.contact.firstName,
          lastName: ctrl.enquiry.contact.lastName
        },
        phone: ctrl.enquiry.contact.phone,
        email: ctrl.enquiry.contact.email
      };

      ctrl.modalInstance = ctrl.$uibModal.open({
        template: _contactEditModal2.default,
        scope: ctrl.$scope
      });
    }
  }, {
    key: 'editContact',
    value: function editContact() {
      var _this5 = this;

      var ctrl = this;

      if (!ctrl.validateContact()) {
        return;
      }

      ctrl.loadingService.showLoading('editEnquiry', 'Saving Contact ...');

      ctrl.contactService.editContact(ctrl.$scope.contact).then(function (response) {
        var contactVm = {
          entityId: ctrl.$scope.contact.entityId,
          contactId: response.data,
          contactTypeId: ctrl.$scope.contact.contactType,
          contactTitleId: ctrl.$scope.contact.contactPerson.title,
          firstName: ctrl.$scope.contact.contactPerson.firstName,
          lastName: ctrl.$scope.contact.contactPerson.lastName,
          name: ctrl.$scope.contact.contactPerson.firstName + ' ' + ctrl.$scope.contact.contactPerson.lastName,
          phone: ctrl.$scope.contact.phone,
          email: ctrl.$scope.contact.email,
          reg: null,
          enquiry: null
        };

        if (_this5.authService.authData.currentLocation.salutationEnabled.enabled) {
          contactVm.name = _this5.getSalutationById(ctrl.$scope.contact.contactPerson.title) + ' ' + ctrl.$scope.contact.contactPerson.firstName + ' ' + ctrl.$scope.contact.contactPerson.lastName;
        }

        ctrl.contactSelected({ originalObject: contactVm });

        ctrl.modalInstance.close();
      }).catch(function (err) {
        if (err.status === 400) {
          ctrl.$scope.errMsg = err.data.map(function (item) {
            return item.value;
          }).toString(',');
        } else {
          ctrl.$scope.errMsg = err.data;
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'quickEditContact',
    value: function quickEditContact() {
      var ctrl = this;

      if (!ctrl.validateContact()) {
        return;
      }

      ctrl.loadingService.showLoading('editEnquiry', 'Saving Contact ...');

      ctrl.$scope.contact.firstName = ctrl.$scope.contact.contactPerson.firstName;
      ctrl.$scope.contact.lastName = ctrl.$scope.contact.contactPerson.lastName;

      ctrl.contactService.quickEdit(ctrl.$scope.contact).then(function (response) {

        var contactVm = {
          entityId: ctrl.$scope.contact.entityId,
          contactId: response.data,
          contactTypeId: ctrl.$scope.contact.contactType,
          contactTitleId: ctrl.$scope.contact.contactPerson.title,
          firstName: ctrl.$scope.contact.firstName,
          lastName: ctrl.$scope.contact.lastName,
          name: ctrl.$scope.contact.contactPerson.firstName + ' ' + ctrl.$scope.contact.contactPerson.lastName,
          phone: ctrl.$scope.contact.phone,
          email: ctrl.$scope.contact.email,
          reg: ctrl.enquiry.contact.reg,
          enquiry: ctrl.enquiry.contact.enquiry
        };

        ctrl.contactSelected({ originalObject: contactVm });

        ctrl.modalInstance.close();
      }).catch(function (err) {
        if (err.status === 400) {
          ctrl.$scope.errMsg = err.data.map(function (item) {
            return item.value;
          }).toString(',');
        } else {
          ctrl.$scope.errMsg = err.data;
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'validateContact',
    value: function validateContact() {
      var ctrl = this;

      ctrl.$scope.errMsg = '';

      if (!(ctrl.$scope.contact.contactPerson.firstName && ctrl.$scope.contact.contactPerson.lastName && ctrl.$scope.contact.phone)) {

        ctrl.$scope.errMsg = 'Please fill in all the fields marked with *';
      }

      return ctrl.$scope.errMsg.length === 0;
    }
  }, {
    key: 'addShowroomEntry',
    value: function addShowroomEntry(details) {
      var ctrl = this;

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editEnquiry', 'Saving Changes ...');

      ctrl.enquiry.details = details;

      ctrl.enquiry.createdBy = ctrl.enquiry.ownerId;
      ctrl.enquiryService.addShowroomEntry(ctrl.enquiry).then(function (response) {
        ctrl.state = 'Saved';
        ctrl.$scope.$broadcast('angucomplete-alt:clearInput', 'searchContacts');

        ctrl.reset();

        if (ctrl.isReceptionist) {
          ctrl.getUserStats();
        }
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(function (item) {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this6 = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        _this6.allBrands = brands;

        _this6.lookupService.lookupBrandModels().then(function (brandModels) {
          _this6.allBrandModels = brandModels;
          deferred.resolve();
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'loadEnumLists',
    value: function loadEnumLists() {
      this.enumLists = {
        transmissionType: this.convertEnumToKeyValueList(this.enums.TRANSMISSION_TYPE),
        fuelType: this.convertEnumToKeyValueList(this.enums.FUEL_TYPE)
      };
    }
  }, {
    key: 'reverseLookup',
    value: function reverseLookup(list, id) {
      var item = (0, _lodash.find)(list, function (o) {
        return o.id === id;
      });

      if (item) {
        return item.name;
      }
    }
  }, {
    key: 'lookupVehicle',
    value: function lookupVehicle() {
      var _this7 = this;

      this.msg = '';

      if (!this.regNo) {
        return;
      }

      this.clearVehicle();

      this.loadingService.showLoading('editEnquiry', 'Looking up vehicle ...');

      this.lookupService.lookupVehicleByRegNo(this.authService.authData.currentLocation.key, 1, this.regNo).then(function (response) {
        _this7.data = response.data;

        _this7.data.make = (0, _lodash.find)(_this7.allBrands, function (o) {
          return o.brandId === _this7.data.brandId;
        }).name;
        _this7.data.model = (0, _lodash.find)(_this7.allBrandModels, function (o) {
          return o.brandModelId === _this7.data.brandModelId;
        }).name;
        _this7.data.transmissionTypeName = _this7.reverseLookup(_this7.enumLists.transmissionType, _this7.data.transmissionType);
        _this7.data.fuelTypeName = _this7.reverseLookup(_this7.enumLists.fuelType, _this7.data.fuelType);

        _this7.serviceVehicle = _this7.data;
      }).catch(function (err) {
        alert('Could not fetch vehicle ' + _this7.regNo + '. Please check registration number or lookup settings and try again');
      }).finally(function () {
        _this7.loadingService.hideLoading('editEnquiry');
      });
    }
  }, {
    key: 'clearVehicle',
    value: function clearVehicle() {
      this.serviceVehicle = null;
    }
  }, {
    key: 'customValidation',
    value: function customValidation() {
      if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Aftersales && !this.serviceVehicle) {
        this.formValidationService.addModelError('servhiceVehicle', 'Please lookup for a vehicle to be serviced');
        return false;
      }

      return true;
    }
  }, {
    key: 'loadDefaultLocation',
    value: function loadDefaultLocation() {
      var defaultLocation = (0, _lodash.find)(this.authService.authData.userLocations, function (o) {
        return o.defaultLocation;
      });
      this.authService.authData.currentLocation = defaultLocation || this.authService.authData.userLocations[0];
    }
  }, {
    key: 'getUserStats',
    value: function getUserStats() {
      var ctrl = this;
      ctrl.userService.getUserStats(ctrl.authService.authData.currentLocation.key).then(function (response) {
        ctrl.userStats = response.data;
      });
    }
  }, {
    key: 'getUserStatItem',
    value: function getUserStatItem(userId, statType) {
      var value = 0;

      if (this.userStats.length) {
        var stat = (0, _lodash.find)(this.userStats, function (o) {
          return o.userId === userId;
        });

        if (stat) {
          return stat[statType];
        }
      }

      return value;
    }
  }, {
    key: 'initializeEnquirySources',
    value: function initializeEnquirySources() {
      var ctrl = this;

      ctrl.enquirySourcesManagementService.list(ctrl.authService.authData.currentLocation.key, true).then(function (response) {
        ctrl.enquirySources = response.data;
        ctrl.enquirySources.unshift({ enquirySourceId: null, name: 'Please Select' });
      });
    }
  }, {
    key: 'getSalutationById',
    value: function getSalutationById(salId) {
      var salList = this.convertEnumToKeyValueList(this.enums.PERSON_TITLE);

      return (0, _lodash.find)(salList, function (o) {
        return o.id === salId;
      }).name;
    }
  }]);
  return WelcomeCentreController;
}();

exports.default = WelcomeCentreController;


// WEBPACK FOOTER //
// ./client/app/components/welcomeCentre/welcomeCentre.controller.js